import chartsPage from '../../pages/ProjectsPage/reducers/init';
import packagesPage from '../../pages/PackagesPage/reducers/init';

export default {
  profile: {
    team: { id: null },
    licenseId: ''
  },
  chartsPage,
  packagesPage
};
